"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CsvMatchingAmountOptionEnum = void 0;
var CsvMatchingAmountOptionEnum;
(function (CsvMatchingAmountOptionEnum) {
    CsvMatchingAmountOptionEnum["NEGATIVE"] = "negative";
    CsvMatchingAmountOptionEnum["POSITIVE"] = "positive";
    CsvMatchingAmountOptionEnum["ALL"] = "all";
})(CsvMatchingAmountOptionEnum || (exports.CsvMatchingAmountOptionEnum = CsvMatchingAmountOptionEnum = {}));
